import Model from '@/models/Model.js';

export default class SlideDeckGroup extends Model {
    static entity = 'slide_deck_group';

    static modelName = 'SlideDeckGroup';

    static primaryKey = ['slide_deck_id', 'group_id'];

    static fields() {
        return {
            id: this.attr(null),
            slide_deck_id: this.attr(null),
            group_id: this.attr(null),

            ...super.fields(),

            slide_deck: this.belongsTo('slide_decks', 'slide_deck_id'),
            group: this.belongsTo('groups', 'group_id'),
        };
    }
}
